import { COMMON_HTTP_MESSAGES } from '../../constants/Http';
import { propertyFieldTypes, propertyReferenceTypes } from '../../constants/properties';
import { toObjectTypes } from '../../constants/types';
import { assignValueToAllObjectKeys } from '../../utils/helpers';
export const RESET_VALIDATION_ERRORS = 'RESET_VALIDATION_ERRORS';
export const RESET_PROPERTY_VALIDATION_ERRORS = 'RESET_PROPERTY_VALIDATION_ERRORS';
export const SET_IS_VALIDATING = 'SET_IS_VALIDATING';
export const VALIDATE_PROPERTY = 'VALIDATE_PROPERTY';
export const START_VALIDATE_PROPERTY = 'START_VALIDATE_PROPERTY';
export const VALIDATE_PROPERTY_FAILED = 'VALIDATE_PROPERTY_FAILED';
export const VALIDATE_PROPERTY_FULFILLED = 'VALIDATE_PROPERTY_FULFILLED';
export const GET_EXTERNAL_OPTIONS = 'GET_EXTERNAL_OPTIONS';
export const GET_EXTERNAL_OPTIONS_REFRESH = 'GET_EXTERNAL_OPTIONS_REFRESH';
export const GET_EXTERNAL_OPTIONS_START = 'GET_EXTERNAL_OPTIONS_START';
export const GET_EXTERNAL_OPTIONS_FAILED = 'GET_EXTERNAL_OPTIONS_FAILED';
export const GET_EXTERNAL_OPTIONS_FULFILLED = 'GET_EXTERNAL_OPTIONS_FULFILLED';
export const SET_MENTION_OWNERS = 'SET_MENTION_OWNERS';
export const GET_PROPERTIES = 'GET_PROPERTIES';
export const SET_PROPERTIES = 'SET_PROPERTIES';
export const SET_IS_PROPERTIES_LOADING = 'SET_IS_PROPERTIES_LOADING';
export const initialState = {
  externalOptions: assignValueToAllObjectKeys(toObjectTypes, {}),
  mentionOwners: [],
  validationErrors: {},
  isValidating: false,
  validatingField: '',
  properties: assignValueToAllObjectKeys(toObjectTypes, {
    defaultSidebarProperties: [],
    defaultProperties: [],
    associationCardProperties: [],
    detailedPropertiesInformation: {}
  }),
  searchProperties: assignValueToAllObjectKeys(toObjectTypes, []),
  arePropertiesLoaded: assignValueToAllObjectKeys(toObjectTypes, false),
  isPorpertiesLoading: false
};
export const reducer = (state, action) => {
  switch (action.type) {
    case RESET_VALIDATION_ERRORS:
      return Object.assign({}, state, {
        validationErrors: {},
        isValidating: false
      });
    case RESET_PROPERTY_VALIDATION_ERRORS:
      return Object.assign({}, state, {
        validationErrors: Object.assign({}, state.validationErrors, {
          [action.payload]: {}
        })
      });
    case SET_IS_VALIDATING:
      return Object.assign({}, state, {
        isValidating: action.payload.value,
        validatingField: action.payload.propertyName || ''
      });
    case START_VALIDATE_PROPERTY:
      {
        const newValidationErrors = Object.assign({}, state.validationErrors);
        action.payload.forEach(({
          name
        }) => {
          newValidationErrors[name] = {};
        });
        return Object.assign({}, state, {
          validationErrors: newValidationErrors
        });
      }
    case VALIDATE_PROPERTY_FAILED:
      {
        const error = action.payload;
        if (error && error.errorMessage !== COMMON_HTTP_MESSAGES.REQUEST_ABORTED) {
          return Object.assign({}, state, {
            isValidating: false,
            validatingField: ''
          });
        }
        return state;
      }
    case VALIDATE_PROPERTY_FULFILLED:
      {
        const newValidationErrors = Object.assign({}, state.validationErrors);
        action.payload.forEach(error => {
          newValidationErrors[error.name] = error;
        });
        return Object.assign({}, state, {
          validationErrors: newValidationErrors,
          isValidating: false,
          validatingField: ''
        });
      }
    case GET_EXTERNAL_OPTIONS_START:
      {
        const {
          crmObjectType,
          referenceType
        } = action.payload;
        const currentOptions = state.externalOptions[crmObjectType][referenceType];
        if (currentOptions) {
          return Object.assign({}, state, {
            externalOptions: Object.assign({}, state.externalOptions, {
              [action.payload.crmObjectType]: Object.assign({}, state.externalOptions[action.payload.crmObjectType], {
                [action.payload.referenceType]: Object.assign({}, currentOptions, {
                  isLoading: true,
                  isError: false
                })
              })
            })
          });
        }
        return Object.assign({}, state, {
          externalOptions: Object.assign({}, state.externalOptions, {
            [action.payload.crmObjectType]: Object.assign({}, state.externalOptions[action.payload.crmObjectType], {
              [action.payload.referenceType]: {
                isLoading: true,
                isError: false
              }
            })
          })
        });
      }
    case GET_EXTERNAL_OPTIONS_FAILED:
      return Object.assign({}, state, {
        externalOptions: Object.assign({}, state.externalOptions, {
          [action.payload.crmObjectType]: Object.assign({}, state.externalOptions[action.payload.crmObjectType], {
            [action.payload.referenceType]: Object.assign({}, state.externalOptions[action.payload.crmObjectType][action.payload.referenceType], {
              isLoading: false,
              isError: true
            })
          })
        })
      });
    case GET_EXTERNAL_OPTIONS_REFRESH:
      return Object.assign({}, state, {
        externalOptions: Object.assign({}, state.externalOptions, {
          [action.payload.crmObjectType]: Object.assign({}, state.externalOptions[action.payload.crmObjectType], {
            [action.payload.referenceType]: Object.assign({}, state.externalOptions[action.payload.crmObjectType][action.payload.referenceType])
          })
        })
      });
    case GET_EXTERNAL_OPTIONS_FULFILLED:
      {
        const {
          crmObjectType
        } = action.payload.options;
        const {
          options,
          data
        } = action.payload;
        const currentOptions = state.externalOptions[crmObjectType][options.referenceType];
        if (!currentOptions || !currentOptions.results) {
          return Object.assign({}, state, {
            externalOptions: Object.assign({}, state.externalOptions, {
              [crmObjectType]: Object.assign({}, state.externalOptions[crmObjectType], {
                [options.referenceType]: Object.assign({}, action.payload.data, {
                  isLoading: false,
                  isError: false
                })
              })
            })
          });
        } else if (currentOptions.results && currentOptions.results.length) {
          return Object.assign({}, state, {
            externalOptions: Object.assign({}, state.externalOptions, {
              [crmObjectType]: Object.assign({}, state.externalOptions[crmObjectType], {
                [options.referenceType]: Object.assign({}, action.payload.data, {
                  results: [...currentOptions.results, ...data.results],
                  isLoading: false,
                  isError: false
                })
              })
            })
          });
        }
        return state;
      }
    case SET_MENTION_OWNERS:
      return Object.assign({}, state, {
        mentionOwners: action.payload
      });
    case SET_PROPERTIES:
      return Object.assign({}, state, {
        arePropertiesLoaded: Object.assign({}, state.arePropertiesLoaded, {
          [action.payload.objectType]: true
        }),
        properties: Object.assign({}, state.properties, {
          [action.payload.objectType]: {
            defaultSidebarProperties: action.payload.data.defaultProperties,
            associationCardProperties: [...action.payload.data.associationCardProperties.primaryProperties, ...action.payload.data.associationCardProperties.secondaryProperties],
            detailedPropertiesInformation: action.payload.data.propertiesDetails.reduce((detailedAcc, property) => Object.assign({}, detailedAcc, {
              [property.name]: {
                label: property.label,
                description: property.description,
                type: property.fieldType === propertyFieldTypes.html ? property.fieldType : property.type
              }
            }), {})
          }
        }),
        searchProperties: Object.assign({}, state.searchProperties, {
          [action.payload.objectType]: action.payload.data.propertiesDetails.map(property => {
            const referenceType = propertyReferenceTypes[property.name];
            return Object.assign({}, property, {
              referenceType
            });
          })
        })
      });
    case SET_IS_PROPERTIES_LOADING:
      return Object.assign({}, state, {
        isPorpertiesLoading: action.payload
      });
    default:
      return state;
  }
};